import * as React from 'react';

import { ISnackbarContext } from '.';
import { SnackbarContext } from './SnackbarContext';

export const useSnackbar = (): ISnackbarContext => {
    const context = React.useContext(SnackbarContext);

    if (!context) {
        throw new Error('useSnackbar must be used within a SnackbarProvider.');
    }

    return context;
};
